import { useCallback, useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { isLastTriageSearchGreaterThanSevenDays, PAGE_ROUTES, useFlags } from '@lyrahealth-inc/shared-app-logic'
import { ProductTypeContext } from '@lyrahealth-inc/ui-core-crossplatform'

import { useNavigateToSearchForCare } from './useNavigateToSearchForCare'
import { getIsUserTeen } from '../../data/user/userSelectors'
import { getSearches } from '../../features/triage/data/triageSelectors'

export const useNavigateToForkedTriage = ({ isBenefitPage }: { isBenefitPage?: boolean } = {}) => {
  const navigate = useNavigate()
  const { isLyraSelect } = useContext(ProductTypeContext)
  const isUserTeen = useSelector(getIsUserTeen)
  const navigateToSearchForCare = useNavigateToSearchForCare()
  const triageSearches = useSelector(getSearches)
  const triageSearchesMemoized = useMemo(() => {
    return triageSearches?.toJS() ?? []
  }, [triageSearches])
  const { shouldShowTriageSummary } = useFlags()
  const showSummaryView =
    shouldShowTriageSummary &&
    isBenefitPage &&
    ((triageSearchesMemoized && triageSearchesMemoized.length === 0) ||
      isLastTriageSearchGreaterThanSevenDays(triageSearchesMemoized))

  return useCallback(
    (preForkedTriageNavigateCallback?: () => void, preTriageNavigateCallback?: () => void) => {
      if (isLyraSelect || isUserTeen) {
        preTriageNavigateCallback && preTriageNavigateCallback()
        navigateToSearchForCare({ showSummaryView })
      } else {
        preForkedTriageNavigateCallback && preForkedTriageNavigateCallback()
        navigate(PAGE_ROUTES.PATHWAYS.FORKED_TRIAGE)
      }
    },
    [isLyraSelect, navigate, navigateToSearchForCare, showSummaryView, isUserTeen],
  )
}
